module.exports = __webpack_public_path__ + "media/img/Landing_Page/website-icon-4de1e4cdd194608966e52e8abf650b46.png";